import { render, staticRenderFns } from "./OrgDetails.vue?vue&type=template&id=37aebcd2&scoped=true&"
import script from "./OrgDetails.vue?vue&type=script&lang=js&"
export * from "./OrgDetails.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/orgdetails.css?vue&type=style&index=0&id=37aebcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aebcd2",
  null
  
)

export default component.exports